import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/css/owl.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/animate.css';
import './assets/css/color.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import './assets/css/flaticon.css';
import './assets/css/font-awesome-all.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <div className='boxed_wrapper'>
      <App />
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
